import HttpClient from './HttpClient';

export default class Webservice {
  baseUrl: string;
  client: HttpClient;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
    this.client = new HttpClient(this.baseUrl);
  }
}
